import { useEffect } from 'react'
import { DadosContainerDefault } from '../../components/Styles'
import Desafios from '../../components/Desafios'

function DesafiosPage() {
    useEffect(() => {
      document.title = 'Desafios | Gesttor'
    })
  return (
    <DadosContainerDefault>
      <Desafios/>
    </DadosContainerDefault>
  )
}

export default DesafiosPage